export const customerTableConfig = {
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '60', align: 'left', slotName: 'consumer'},
    {prop: 'unionId', label: '客户unionId', minWidth: '60', slotName: 'unionId'},
    {prop: 'createdAt', label: '进入售后时间', minWidth: '60'},
  ]
}
